import React from 'react';
import { CircularProgress, styled } from '@mui/material';

const Container = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1400,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'rgba(250, 250, 250, 0.5)',
});

const Loading: React.FC = () => {
  return (
    <Container>
      <CircularProgress color="primary" />
    </Container>
  );
};

export default Loading;
